import React from "react";
import FlightCheckerBase from "./FlightCheckerBase";

export default function FlightChecker() {
  return (
    <FlightCheckerBase
      defaultFlight="BA005"
      title="Heathrow Flight Checker | Live Flight Status, Terminal, Gate, Queues & Reliability"
      metaDescription="Check Heathrow flights by number with live Heathrow flight status, terminal, gate, check-in zone, aircraft, reliability, arrivals/departures and latest security or immigration queue times."
      metaKeywords="Heathrow flight checker, Heathrow flight status, Heathrow arrivals, Heathrow departures, Heathrow terminal finder, Heathrow gate number, Heathrow check-in zone, Heathrow immigration queue times, Heathrow security queue times, Heathrow flight reliability, Heathrow live flight tracker"
      canonical="https://www.cheapcabgrab.com/flight-checker"
      ogTitle="Heathrow Flight Checker | Live Status, Terminal, Gate & Queue Times"
      ogDescription="Check Heathrow flights by number for live status, terminal, gate, check-in zone, flight reliability, aircraft type and latest security or immigration queue times."
      schemaName="CheapCabGrab Heathrow Flight Checker"
      breadcrumbName="Flight Checker"
      headerTitle="Heathrow Flight Checker"
      headerIntro="Check Heathrow arrivals and departures by flight number, with terminal, gate, queue times and recent reliability context."
      headerNote="Choose the exact Heathrow arrival or departure time to get the right flight occurrence, including today, recent past flights and the next few days."
      inputPlaceholder="e.g. BA005, EK042, KU103"
      emptyInputMessage="Please enter a flight number (e.g. BA005, EK042)"
      notFoundMessage="Flight not found at Heathrow for the selected time. Please choose another listed flight."
      resultHeading="Heathrow Flight Details"
      pickupLabel="Calculate pickup window →"
      faqTitle="FAQs"
      faqItems={[
        {
          question: "How long after landing should I arrive for pickup?",
          answer: "Usually 45–90 minutes for long-haul; peaks can reach 2 hours. Wait nearby until they are landside.",
        },
        {
          question: "Do eGates make it faster?",
          answer: "Yes, but evening peaks can still slow queues.",
        },
        {
          question: "Should I enter Short Stay early?",
          answer: "No. Enter only when your passenger confirms they are at the exit.",
        },
        {
          question: "Why does my flight say “Expected” multiple times?",
          answer: "Heathrow refreshes estimated arrival times as aircraft approach; multiple “Expected” updates are normal.",
        },
        {
          question: "What if my passenger has checked bags?",
          answer: "Add 15–40 minutes for reclaim; widebody arrivals can add more.",
        },
        {
          question: "Which terminal is usually slowest?",
          answer: "It varies; T5 can be longer due to size and remote stands, and T4 can slow down due to layout.",
        },
      ]}
      toolsLinks={[
        { href: "/train-vs-taxi", label: "Compare taxi vs train." },
        { href: "/heathrow-parking-vs-taxi", label: "See whether parking or taxi is cheaper." },
        { href: "/heathrow-taxi", label: "Book a Heathrow taxi transfer." },
        { href: "/terminalFinder", label: "Find your terminal." },
        { href: "/leave-for-heathrow", label: "When to leave for Heathrow" },
        { href: "/arrival-assistant", label: "Arrival assistant" },
      ]}
    />
  );
}
